import { useState } from "react";
import ForgotPassword from "./ForgotPassword";
import LoginComponent from "./LoginComponent";

const RightContent = () => {
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        width: "50%",
        height: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "1.25rem",
          color: "#555555",
          gap: "1.25rem",
          width: "100%",
        }}
      >
        {!isForgotPassword ? (
          <LoginComponent setIsForgotPassword={setIsForgotPassword} />
        ) : (
          <ForgotPassword setIsForgotPassword={setIsForgotPassword} />
        )}
      </div>
    </div>
  );
};

export default RightContent;
